<div class="d-flex align-items-center">
  <div>
    <button
      class="mr-2"
      [ngClass]="isCycle ? 'filter-button-active' : 'default-button'"
      mat-button
      color="{{ isCycle ? 'primary' : '' }}"
      (click)="cycleDateWithin7Days()"
    >
      Cycle data within 7 days
    </button>
  </div>

  <div class="dropright">
    <button
      class="btn btn-sm btn-clean mr-2 dropdown-toggle"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      FILTER
      <i class="ml-2 ki ki-arrow-down text-primary"></i>
    </button>

    <div
      class="dropdown-menu p-5 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-xl"
      (click)="$event.stopPropagation()"
    >
      <div class="col-md-12 mb-5">
        <mat-label style="color: rgba(0, 0, 0, 0.6)">Cycle Date</mat-label>
        <div class="row" style="padding: 0 12.5px">
          <div class="col-md-5">
            <mat-form-field class="pl-0" appearance="fill">
              <mat-label>From Date</mat-label>
              <input
                matInput
                [matDatepicker]="fromPicker"
                [formControl]="fromDate"
                (dateChange)="dispatchEvent()"
                placeholder="MM/DD/YYYY"
                [(ngModel)]="fromDateModel"
                ktDateMask
                maxlength="10"
              />
              <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
              <mat-datepicker #fromPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-md-5">
            <mat-form-field class="pl-0" appearance="fill">
              <mat-label>To Date</mat-label>
              <input
                matInput
                [matDatepicker]="toPicker"
                [formControl]="toDate"
                (dateChange)="dispatchEvent()"
                placeholder="MM/DD/YYYY"
                ktDateMask
                maxlength="10"
              /><mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
              <mat-datepicker #toPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-2">
            <a
              (click)="clearDateFilter()"
              class="text-primary cursor-pointer p-0"
              style="display: flex; align-items: center"
              >Clear</a
            >
          </div>
        </div>
      </div>

      <div class="col-md-12 mb-5">
        <kt-general-autocomplete
          [label]="'Patient'"
          [loadItemsFunction]="filterPatientFn"
          [optionFormatter]="stringUtilsService.displayFullName"
          [valueFormatter]="stringUtilsService.displayName"
          [required]="false"
          [readOnly]="false"
          [change]="selectedPatient.bind(this)"
          [dataPath]="'data'"
          [placeholder]="''"
          [hint]="'GLOBAL.FILTER_BY' | translate"
          [hintStrong]="'Patient'"
          #patientAutocomplete
        ></kt-general-autocomplete>
      </div>
      <div class="col-md-12 mb-5">
        <kt-general-autocomplete
          #doctorAutocomplete
          [label]="'Doctor'"
          [dataPath]="'data'"
          [loadItemsFunction]="getDoctorAutocomplete"
          [optionFormatter]="stringUtilsService.displayFullName"
          [valueFormatter]="stringUtilsService.displayName"
          [change]="dispatchEvent.bind(this)"
          [control]="doctorAutocomplete"
          [required]="false"
          [readOnly]="false"
          [hint]="'GLOBAL.FILTER_BY' | translate"
          [hintStrong]="'Doctor'"
        ></kt-general-autocomplete>
      </div>
      <div class="col-lg-12 mb-5">
        <kt-general-autocomplete
          [label]="'PATIENT.INPUT.FACILITY' | translate"
          [loadItemsFunction]="facilityAutocompleteCall"
          [optionFormatter]="stringUtilsService.autocompleteEntityFormatter"
          [valueFormatter]="stringUtilsService.displayName"
          [required]="false"
          [readOnly]="false"
          [change]="onFacilityChange.bind(this)"
          [placeholder]="'Search Facilities'"
          [dataPath]="'data'"
          [hint]="'GLOBAL.FILTER_BY' | translate"
          hintStrong="Facility"
          #facilityAutocomplete
        ></kt-general-autocomplete>
      </div>
      <div class="col-lg-12 mb-5">
        <kt-general-autocomplete
          [label]="'Office'"
          [loadItemsFunction]="officeAutocompleteCall"
          [optionFormatter]="officeOptionFormatter"
          [valueFormatter]="officeOptionFormatter"
          [readOnly]="false"
          [change]="onOfficeChange.bind(this)"
          [placeholder]="'Office'"
          [hint]="'GLOBAL.FILTER_BY' | translate"
          hintStrong="Office"
          #officeAutocompleteComponent
        ></kt-general-autocomplete>
      </div>
      <div class="col-lg-12 mb-5">
        <mat-form-field appearance="fill" class="col status-field p-0">
          <mat-label>Badge</mat-label>
          <mat-select [formControl]="badge" (selectionChange)="badgeChange()">
            <mat-option value=""> All </mat-option>
            <mat-option value="NTS"> NTS </mat-option>
            <mat-option value="DOSE"> DOSE </mat-option>
            <mat-option value="RES"> RES </mat-option>
            <mat-option value="HOA"> HOA </mat-option>
            <mat-option value="FREQ"> FREQ </mat-option>
            <mat-option value="HOLD"> HOLD </mat-option>
            <mat-option value="ADM"> ADM </mat-option>
            <mat-option value="RADM"> RADM </mat-option>
            <mat-option value="ACUTE">ACUTE</mat-option>
          </mat-select>
          <mat-hint>{{ 'GLOBAL.FILTER_BY' | translate }}<strong>Badge</strong></mat-hint>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
